import { JsonPipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SettingsService } from 'core-lib';
import { PasswordModule } from 'primeng/password';
import { Button } from "primeng/button";


export interface PimConfigurationResponse {
  tenantId: string;
  configurationSource: string;
  pimSettingsAvailable: boolean;
  items: ConfigurationItem[];
  summary: Summary;
  groups: ConfigurationGroup[];
}

export interface ConfigurationItem {
  path: string;
  configuredValue: string;
  status: string;
  mappingType: string;
  pimKeys: string[];
  hotelId?: number;
  message?: string;
}

export interface Summary {
  totalCount: number;
  appliedCount: number;
  missingCount: number;
  errorCount: number;
}

export interface ConfigurationGroup {
  name: string;
  summary: Summary;
  items: ConfigurationItem[];
}

@Component({
    selector: 'app-admin',
    imports: [JsonPipe, FormsModule, PasswordModule, Button],
    templateUrl: './admin.component.html',
    styleUrl: './admin.component.scss'
})
export class AdminComponent {


  pwd: string = '';
  pwdAccepted: boolean = false;
  statusObject: PimConfigurationResponse | null = null;

  constructor(private http: HttpClient, private settings: SettingsService) { }

  ngOnInit() {
    
    
  }

  checkPwd() {
    if (this.pwd === 'hotellinx') {
      this.pwdAccepted = true;
      this.diagnoseSettings();
    } else {
      alert('Incorrect password');
    }
  }

  diagnoseSettings() {
    let endpoint = this.settings.getEndpoint();
    let url = `${endpoint}/content/moduleconfig/pim-status`;
    this.http.get<PimConfigurationResponse>(url).subscribe({
      next: (response) => {
        this.statusObject = response;
        console.log('PIM status:', response);
      },
      error: (error) => {
        console.error('Error fetching PIM status:', error);
      }
    });

  }

  getParsed(value: string): any {
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }
}
